export const config = {
  CURRENCY_API_KEY: "91abe26df585035b756483145e6c7d76",
};

